import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BootstrapProvider } from './contexts/BootstrapContext';
import analytics from './services/analytics';

// Initialize analytics (GA4 + Source Digital pixel). No-op unless the
// production env vars are set, so dev/staging never sends data.
analytics.init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BootstrapProvider>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </BootstrapProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
